var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "basic-task" } }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("a-input", {
          staticClass: "basic-task-input",
          attrs: { placeholder: _vm.$t("task.enterNewTaskTitle") },
          model: {
            value: _vm.form.title,
            callback: function ($$v) {
              _vm.$set(_vm.form, "title", $$v)
            },
            expression: "form.title",
          },
        }),
        _vm._v(" "),
        _c("a-textarea", {
          staticClass: "basic-task-input",
          attrs: {
            placeholder: _vm.$t("task.enterNewTaskDesc"),
            "auto-size": { minRows: 3, maxRows: 5 },
          },
          model: {
            value: _vm.form.description,
            callback: function ($$v) {
              _vm.$set(_vm.form, "description", $$v)
            },
            expression: "form.description",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "basic-task-assignee" },
          [
            _c("label", [_vm._v(_vm._s(_vm.$t("task.assignee")))]),
            _vm._v(" "),
            _c("a-select", {
              staticClass: "select-multiple",
              attrs: {
                mode: "multiple",
                placeholder: _vm.$t("task.selectAssginee"),
                options: _vm.visibilityUsers,
                "filter-option": _vm.filterOption,
              },
              model: {
                value: _vm.form.assigneeIds,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "assigneeIds", $$v)
                },
                expression: "form.assigneeIds",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "basic-task-footer" }, [
          _c(
            "div",
            {
              staticStyle: { display: "contents" },
              on: { click: _vm.closeForm },
            },
            [
              _c("md-icon", { staticClass: "basic-task-close-btn" }, [
                _vm._v("close"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { on: { click: _vm.createTask } },
            [
              _c("md-icon", { staticClass: "basic-task-done-btn" }, [
                _vm._v("done"),
              ]),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }